import Raven from 'raven-js';
const findMessageInError = error => {
  var _error$data, _error$netWorkError;
  if (!error) {
    return 'unknown error message - UI Deal Management Components Lib';
  }
  return ((_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || error.errorCode || ((_error$netWorkError = error.netWorkError) === null || _error$netWorkError === void 0 ? void 0 : _error$netWorkError.message) || error.message || error.errorMessage || JSON.stringify(error);
};
export const logRavenException = (error, transaction, data) => {
  let errorMessage = '';
  try {
    var _JSON$parse2;
    // try catch for json parse - rest of attempts should be safe
    if (error.name === 'ApolloError') {
      var _JSON$parse;
      errorMessage = (_JSON$parse = JSON.parse(error.networkError.data)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.message;
    } else if (error.data && (_JSON$parse2 = JSON.parse(error.data)) !== null && _JSON$parse2 !== void 0 && _JSON$parse2.message) {
      errorMessage = JSON.parse(error.data).message;
    } else {
      errorMessage = findMessageInError(error);
    }
  } catch (_unused) {
    errorMessage = findMessageInError(error);
  }
  Raven.captureException(error, {
    extra: {
      error: errorMessage,
      data,
      transaction
    }
  });
};